import * as React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { useSimpleNavigationCallback } from "seneca-common/utils/hooks/routing";
import { logSignUpEventByAccountType } from "seneca-common/utils/senecaAnalytics";

import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import { linkToAddCoursesPage } from "features/dashboard/pages/courses-page/links";
import SignUpStudentDetailsForm from "features/sign-up/sign-up-form/components/SignUpFormStudentDetails";
import { getUserAccountType } from "features/user/selectors";

type Props = {
  pageNumber: number;
  totalNumberOfPages: number;
  linkToSignUpAccountType: string | null | undefined;
  redirectAuthenticatedUserTo: string | null | undefined;
};

export const makeSignUpDetails =
  (
    Component: React.ComponentType<any>,
    defaultHomePagePath: string = linkToAddCoursesPage()
  ) =>
  ({
    redirectAuthenticatedUserTo,
    linkToSignUpAccountType,
    ...other
  }: Props) => {
    const location = useLocation();
    const accountType = useSelector(getUserAccountType);

    const redirectTo = redirectAuthenticatedUserTo || defaultHomePagePath;

    const navigateToDefaultOrTargetRoute =
      useSimpleNavigationCallback(redirectTo);

    const onBackClick =
      linkToSignUpAccountType &&
      useSimpleNavigationCallback(
        makeInternalRedirectState({
          pathname: linkToSignUpAccountType as any,
          state: location.state
        } as any) as any
      );

    const onSignUpDetailsComplete = () => {
      logSignUpEventByAccountType(accountType!);
      navigateToDefaultOrTargetRoute();
    };

    return (
      <Component
        {...other}
        onBackClick={onBackClick}
        onExtraSignUpDetailsSuccess={onSignUpDetailsComplete}
      />
    );
  };

// @ts-ignore
export default makeSignUpDetails(SignUpStudentDetailsForm);
